module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _c('a', {
    attrs: {
      "id": "map"
    }
  }, [_vm._v("List of Maps")])]), _c('a', {
    attrs: {
      "id": "map"
    }
  }, [_c('p', {
    staticClass: "map"
  }, [_vm._v("General map of the area")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("A map drawn by Captain Eric Jones showing the deployment of the 2/Gloucesters at Cassel")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("A map drawn by Captain Bill Wilson showing the deployment of B and D Companies at Cassel")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("A map taken from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Contemptibles")]), _vm._v(" showing the 5/RHA positions at Hondeghem")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("A map taken from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Contemptibles")]), _vm._v(" showing the 5/RHA positions at St-Sylvestre-Cappel")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("A map of the Woodforce deployment at Hazebrouck")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("A map showing the deployment of the 1/Bucks at Hazebrouck")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("A map taken from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ox and Bucks Regimental Journal, July 1943")]), _vm._v(", depicting the 1/Bucks’ positions at Hazebrouck")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("Car Tour 1")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("Walk 2")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-397ed42a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_List_of_Maps.vue
// module id = 69
// module chunks = 0